import { ExternalLink, CheckCircle2 } from "lucide-react";
import { Button } from "./ui/button";
import { siteData } from "../data/mock";

export const GongjindanSection = () => {
    const { gongjindan } = siteData;

    return (
        <section
            id="gongjindan"
            className="py-24 relative overflow-hidden bg-white"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="lg:grid lg:grid-cols-2 lg:gap-16 items-center">
                    <div className="order-2 lg:order-1 lg:pr-8">
                        <div className="inline-flex items-center space-x-2 px-3 py-1 rounded-full bg-[#BCA182]/10 text-[#BCA182] text-[11px] font-bold uppercase tracking-widest mb-6">
                            <span className="relative flex h-2 w-2">
                                <span className="animate-ping absolute inline-flex h-full w-2 rounded-full bg-[#BCA182] opacity-75"></span>
                                <span className="relative inline-flex rounded-full h-2 w-2 bg-[#BCA182]"></span>
                            </span>
                            <span>Premium Wellness</span>
                        </div>

                        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-semibold text-[#232323] mb-6 tracking-tight leading-tight" style={{ fontFamily: '"Cormorant Garamond", serif' }}>
                            {gongjindan.title}
                        </h2>

                        <p className="text-xl text-[#BCA182] font-medium mb-4 italic">
                            {gongjindan.subtitle}
                        </p>

                        <p className="text-lg text-stone-600 leading-relaxed mb-8">
                            {gongjindan.description}
                        </p>

                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10">
                            {gongjindan.highlights.map((highlight, index) => (
                                <div key={index} className="flex items-center space-x-3 text-stone-700">
                                    <CheckCircle2 className="w-5 h-5 text-[#5E8C61]" />
                                    <span className="font-medium">{highlight}</span>
                                </div>
                            ))}
                        </div>

                        <div className="flex flex-col sm:flex-row gap-4">
                            <Button
                                asChild
                                className="bg-[#232323] hover:bg-[#333333] text-white px-8 py-6 rounded-lg text-lg transition-all duration-300 shadow-lg hover:shadow-xl"
                            >
                                <a
                                    href={gongjindan.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="flex items-center justify-center gap-2"
                                >
                                    Shop Now
                                    <ExternalLink className="w-5 h-5" />
                                </a>
                            </Button>
                            <Button
                                variant="outline"
                                className="border-stone-200 text-stone-600 hover:bg-stone-50 px-8 py-6 rounded-lg text-lg transition-all duration-300"
                                onClick={() => document.getElementById('locations')?.scrollIntoView({ behavior: 'smooth' })}
                            >
                                In-Clinic Inquiry
                            </Button>
                        </div>
                    </div>

                    <div className="order-1 lg:order-2 relative mb-12 lg:mb-0">
                        <div className="max-w-sm mx-auto lg:ml-auto lg:mr-0">
                            <div className="aspect-square rounded-2xl overflow-hidden shadow-2xl relative z-10">
                                <img
                                    src={gongjindan.image}
                                    alt="Premium Gongjindan"
                                    className="w-full h-full object-cover transform hover:scale-105 transition-transform duration-700"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-black/10 to-transparent pointer-events-none" />
                            </div>
                            {/* Decorative elements */}
                            <div className="absolute -top-6 -right-6 w-32 h-32 bg-[#F0E6D8] rounded-full mix-blend-multiply opacity-70 animate-blob" />
                            <div className="absolute -bottom-8 -left-8 w-40 h-40 bg-[#C5D4C0] rounded-full mix-blend-multiply opacity-50 animate-blob animation-delay-2000" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};
